import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {User} from 'main/stores/users';
import TimeOffRequest from './TimeOffRequest';
import {calendarDate} from 'shared/tools';

class TimeOffTransaction extends DomainObject {
  @observable id;
  @observable postedOn;
  @observable transactionType;
  @observable createdByUser;
  @observable timeOffRequest;
  @observable amount;
  @observable notes;

  @action merge(other) {
    super.merge(other, {
      _dates: ['postedOn'],
      createdByUser: User,
      timeOffRequest: TimeOffRequest
    });
  }

  @computed get hasAmount() {
    return this.amount !== null;
  }

  @computed get postedOnView() {
    return calendarDate(this.postedOn);
  }
}

export default TimeOffTransaction;
